import './styles.css';
import { refreshOnReturn, renderLanding } from './pages/landing';

const app = document.getElementById('app')!;
void renderLanding(app);
refreshOnReturn(app);
